import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import MgiRiskAngularSdkInstance from 'mgiriskangularsdk';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { ErrorService } from 'src/app/services/error.service';
import { RiskStatus } from 'src/app/store/auth/auth.model';

@Component({
  selector: 'app-risk-sdk',
  templateUrl: './risk-sdk.component.html',
  styleUrls: ['./risk-sdk.component.scss']
})
export class RiskSdkComponent {
  @Output() riskSdkCompleteEvent = new EventEmitter<void>()
  @Input() steps: { [id: string]: number }
  @Input() set currentStep(currentStep: number) {
    // Todo: Tim: should revisit this implementation. There is likely a better way to trigger the modal to launch after
    if (this.steps && currentStep === this.steps['riskSdk']) {
      this.handleOpen()
    }
  }
  
  private key: string
  private journeyToken: string
  @Input() public set riskStatus(riskStatus: RiskStatus) {
    console.log('riskStatus', riskStatus) // todo: remove: #may6
    if (riskStatus?.journeyKey && riskStatus?.journeyToken) {
      this.key = riskStatus.journeyKey
      this.journeyToken = riskStatus.journeyToken
    }
  } 

  @Input() cmsLabels: any // Todo: Tim: fix types

  public isOpen: boolean = false;
  private alloySDK: any = null;

  constructor(
    private sanitizer: DomSanitizer, 
    private errorService: ErrorService
  ) {}

  ngOnInit(): void {
    // console.log('riskSDK onInit...', this.riskStatus); // Todo: remove: #may6
    // console.log('this.key', this.key); // Todo: remove: #may6
    // console.log('this.journeyToken', this.journeyToken); // Todo: remove: #may6
    const payload = {
      "key": this.key,
      "journeyToken": this.journeyToken,
      "journeyApplicationToken": null,
      "production": false,
      "appURL": null,
      "apiURL": null,
      "entityToken": null,
      "isSingleEntity": null,
      "showHeader": null,
      "color": null
    }
    // console.log('JSON.stringify(payload)', JSON.stringify(payload)); // TODO: #may6 
    try {
      const alloyInitParams = {
        isReactNative: false,
        debugMode: false,
        actionProvider: "ALLOY",
        providerSdkPayload: JSON.stringify(payload)
      };
      this.alloySDK = MgiRiskAngularSdkInstance.initialize(alloyInitParams)
    } catch (error) {
      console.error('Alloy SDK initialization failed:', error)
    }
  }

  public handleOpen(): void {
    if (this.alloySDK) {
      try {
        const anchorElementId = 'renderComponent';
        MgiRiskAngularSdkInstance.open(this.callback, anchorElementId);
        this.isOpen = true;  // Mark modal as open
      } catch (error) {
        console.error('Failed to open Alloy modal:', error);
      }
    } else {
      console.error('Alloy SDK not initialized.');
    }
  }

  public handleClose(): void {
    if (this.alloySDK) {
      try {
        MgiRiskAngularSdkInstance.close();
        this.isOpen = false;
      } catch (error) {
        console.error('Failed to close Alloy modal:', error);
      }
    } else {
      console.error('Alloy SDK not initialized.');
    }
  }

  callback = (data: any): void => {
    console.log("Callback data:", data); // Todo: #may6 - can we remove: this?
    const status = MgiRiskAngularSdkInstance.getStatus(data)
    if (data.sdk.sdkEvent === 'exit') {
      console.log('getStatus', MgiRiskAngularSdkInstance.getStatus(data));  // Log status of the modal event
      this.isOpen = false;  // Set `isOpen` to `false` when the modal is exited
      console.log("Modal exited. isOpen set to:", this.isOpen);
      // console.log("risk-sdk - emitting riskSdkCompleteEvent"); // Todo: remove: #may6
      // Todo: Tim: #may6 - Need to setup specific cases on how to handle completion of RIsk SDK, based on API response.
      if (status === 'ALLOW' || status === 'WAIT') {
        this.riskSdkCompleteEvent.emit()
      }
      else if (status === 'NOT_ALLOW') {
        // Todo: Tim: #may6 - handle NOT-ALLOW status
        this.errorService.open('_unable to verify identity', this.cmsLabels.stellar.dismiss)
      }
      else {
        // Todo: Tim: #may6 - fix routing if status is not available
        // this.errorService.open('_ERROR', this.cmsLabels.stellar.dismiss) // Todo: #may6 - revert
        console.error('Error during id verification')
        this.riskSdkCompleteEvent.emit() // Todo: remove: #may6
      }
    }
  }
}

